// @ts-nocheck
import React from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  useParams,
} from 'react-router-dom';
import File from './File';

function Download() {
  const { fileid, filename } = useParams();
  console.log('QueryParam: ' + fileid);

  return (
    <Redirect
      to={{ pathname: '/File', state: { id: fileid, name: filename } }}
    />
  );
}

export default function App() {
  return (
    <Router>
      <React.Fragment>
        <div>
          <Switch>
            <Route path='/File' render={(props) => <File {...props} />} />
            <Route path='/:fileid/:filename'>
              <Download />
            </Route>
            <Route path='/File'>
              <File />
            </Route>
          </Switch>
        </div>
      </React.Fragment>
    </Router>
  );
}
